<template>
    <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" loading-text="Loading" pulling-text="Pulling"
        success-duration="1000">
        <template #loading>
            <div class="loading-content">
                <div class="loading-spinner">
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                </div>
            </div>
        </template>
        <template #loosing>
            <div class="loading-content">
                <div class="loading-spinner">
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                </div>
            </div>
        </template> -->
        <div class="like-container">
            <!-- 🔧 错误状态显示 -->
            <div v-if="mineStore.likeError && !mineStore.likeLoading" class="error-state">
                <div class="error-content">
                    <div class="error-icon">
                        <div class="error-icon-circle">!</div>
                    </div>
                    <div class="error-text">No network</div>
                    <div @click="handleRetry" class="retry-btn">Retry</div>
                </div>
            </div>
            <!-- 🔧 正常内容显示 -->
            <template v-else>
                <div class="cards-grid" v-if="!mineStore.likeLoading">
                    <AppCard v-for="item in mineStore.likeList" :key="item.id" :info="item" class="card-item"
                        :isShowTags="false" :isLike="true" />
                </div>
                <div v-else>
                    <SkeletonPresets preset="card" :loading="true" :animated="true" />
                </div>
                <div v-if="mineStore.likeList.length === 0 && !mineStore.likeLoading" class="min-h-50vh">
                    <AppEmpty :imgSrc="likeEmpty" :show-btn="true" />
                </div>
            </template>
        </div>
    <!-- </van-pull-refresh> -->
</template>

<script setup lang="ts">
import { AppCard } from '@/components/display'
import { SkeletonPresets } from '@/components/display'
import { AppEmpty } from '@/components/display'
import { useMineStore } from '@/stores/mine'
import { onMounted, ref } from 'vue'
import likeEmpty from '@/assets/images/message/like_empy.webp'

const mineStore = useMineStore()
const refreshing = ref(false)

/**
 * 下拉刷新
 */
const onRefresh = async () => {
    try {
        refreshing.value = true
        await mineStore.refreshLikeList()
    } catch (error) {
        console.error('刷新失败:', error)
    } finally {
        refreshing.value = false
    }
}

/**
 * 🔧 重试加载
 */
const handleRetry = async () => {
    try {
        await mineStore.fetchLikeList()
    } catch (error) {
        console.error('重试失败:', error)
    }
}

onMounted(async () => {
    // 如果未初始化，则获取数据
    if (!mineStore.likeInitialized) {
        await mineStore.fetchLikeList()
    }
})
</script>

<style scoped lang="scss">
.cards-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    width: 100%;
}

.card-item {
    width: 100%;
}

.btn {
    width: 210px;
    height: 36px;
    background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
    border-radius: 20px;
}

.van-pull-refresh {
    overflow: visible !important;
}

.loading-content {
    display: flex;
    align-items: center;
    gap: 12px;
    opacity: 0.8;

    .loading-spinner {
        display: flex;
        gap: 4px;

        .spinner-ring {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: linear-gradient(135deg, #C489FF 0%, #6868FF 100%);
            animation: spinner-bounce 1.4s ease-in-out infinite both;

            &:nth-child(1) {
                animation-delay: -0.32s;
            }

            &:nth-child(2) {
                animation-delay: -0.16s;
            }

            &:nth-child(3) {
                animation-delay: 0;
            }
        }
    }
}

// 弹跳动画
@keyframes spinner-bounce {
    0%,
    80%,
    100% {
        transform: scale(0.8);
        opacity: 0.5;
    }

    40% {
        transform: scale(1.2);
        opacity: 1;
    }
}

:deep(.van-pull-refresh__head) {
    display: flex;
    align-items: center;
    justify-content: center;
}

// 🔧 错误状态样式
.error-state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    padding: 40px 20px;

    .error-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .error-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            opacity: 0.8;

            .error-icon-circle {
                width: 60px;
                height: 60px;
                border-radius: 50%;
                background: rgba(214, 80, 80, 0.2);
                border: 2px solid #D65050;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #D65050;
                font-size: 32px;
                font-weight: 900;
                line-height: 1;
            }
        }

        .error-text {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.6);
            margin-bottom: 20px;
        }

        .retry-btn {
            font-family: Avenir, Avenir;
            font-weight: 500;
            font-size: 14px;
            color: #7284F7;
            cursor: pointer;
            text-align: center;
            border-radius: 20px;
            border: 1px solid #7284F7;
            width: 100px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: opacity 0.3s;

            &:active {
                opacity: 0.8;
            }
        }
    }
}
</style>